import { EpiSettings } from "../dto/epi-settings";
import Geocode from "react-geocode";
import Point from "@arcgis/core/geometry/Point";
import { getPageProperties } from "./cps-school-api";
import { CHICAGO } from "./map-controller";
import { getMapYear } from "../components/results/map-container-config";
import { Query } from "../../../search/app/functions/query";
import { resolve } from "dns";
import { Mode } from '../interfaces'
export const METERS_PER_MILE = 1609.34;

export function getMapName(name, year, mode: Mode  = 'gocps', extraQuery = {}) {

    return getMapYear(name, mode).then(overrideYear => {
        let mapYear = overrideYear || year;
        const queryString = new URLSearchParams({
            mapName: name,
            year: mapYear,
            ...extraQuery
        })
        return fetch(`/api/maps/GeoJSON?${queryString}`)
            .then(res => {
                return res.json()
            })
    });

}

export function nearMeSearch(radius, type) {
    return new Promise<{ ids: number[], address: string, pos: { lat: number, lng: number } }>((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(position => {
            const lat = position.coords.latitude;
            const long = position.coords.longitude;
            Promise.all([
                radiusSearch(lat, long, radius, type),
                getReverseGeocode(lat, long)
            ]).then(([ids, address]) => {
                resolve({
                    ids: ids,
                    address: address,
                    pos: { lat: lat, lng: long }
                });
            });
        });
    })
}

// @TODO refactor to  work with overrides
export function radiusSearch(lat, long, radius, type) {
    const year = '2022';
    if (type == 'gocps' || type == 'prog') {
        let name = 'School';
        //return fetch(`/api/maps/GeoJSON?mapName=${name}&year=${year}&latitude=${lat}&longitude=${long}&radius=${radius * 1609}`)
        return getMapName(name, year, 'gocps', {
            latitude: lat,
            longitude: long,
            radius: radius * 1609
        })
            .then(res => res.features.map(s => type == 'cps' ? s.properties.School_ID : s.properties.School_ID))
    } else {
        return Promise.all([
            //fetch(`/api/maps/GeoJSON?mapName=DFSS&year=${year}&latitude=${lat}&longitude=${long}&radius=${radius * 1609}`).then(res => res.json()),
            getMapName('DFSS', year, 'prek', {
                latitude: lat,
                longitude: long,
                radius: radius * 1609
            }),
            getMapName('CPS_PREK', year, 'prek', {
                latitude: lat,
                longitude: long,
                radius: radius * 1609
            })
            //fetch(`/api/maps/GeoJSON?mapName=CPS_PREK&year=${year}&latitude=${lat}&longitude=${long}&radius=${radius * 1609}`).then(res => res.json())
        ]).then(res => {
            const dfss = res[0].features;
            const cps = res[1].features;
            const cpsPrek = cps.filter(s => {
                return s.properties.Grades.split(', ').includes('PK')
            })
            const combined = [...dfss, ...cpsPrek];
            return combined.map(s => s.properties.School_ID);
        })

    }
}

type GeocodedAddress = {
    address: string,
    location: {
        lat;
        lng;
    }
}

function googleGeocode(address): Promise<GeocodedAddress | null> {
    const googleGeocoder = new google.maps.Geocoder();
    return googleGeocoder.geocode({ address: address }).then(res => {
        if (res.results.length > 0) {
            return {
                address: res.results[0].formatted_address,
                location: {
                    lat: res.results[0].geometry.location.lat(),
                    lng: res.results[0].geometry.location.lng()
                }
            }
        }
        return null;
    })
}

function esriGeocode(address): Promise<GeocodedAddress | null> {
    // @ts-ignore
    return fetch(`https://api.cps.edu/maps/Geocoder/AddressGeocode?address=${address}`)
        .then(res => res.json())
        .then(res => {
            if (res.candidates.length > 0) {
                const point = Point.fromJSON({
                    ...res.candidates[0].location,
                    spatialReference: res.spatialReference
                });
                return {
                    address: res.candidates[0].address,
                    location: {
                        lat: point.latitude,
                        lng: point.longitude
                    }
                }
            }
            return null;
        })
}

export function addressGeocode(address): Promise<GeocodedAddress | null> {
    return getPageProperties().then(props => {
        if (props.bypassEsri) {
            return googleGeocode(address);
        }
        return esriGeocode(address).catch(err => {
            return googleGeocode(address)
        });
    })


}

export function esriAddressSuggestions(term) {
    return fetch(`https://api.cps.edu/maps/Geocoder/AddressSuggestions?address=${term}`)
        .then(res => res.json())
        .then(res => res.suggestions.map(s => s.text))

}

export function googleAddressSuggestions(term) {
    const service = new google.maps.places.AutocompleteService();
    return service.getPlacePredictions({
        input: term,
        location: new google.maps.LatLng(CHICAGO),
        radius: 16 * METERS_PER_MILE,
        types: ['address']
    }).then(res => {
        return res.predictions.map(location => location.description).filter(a => /^[0-9].*Chicago.*/.test(a))
    });
}

export function addressSuggeestions(term) {
    return googleAddressSuggestions(term)
}



// @TODO refactor to  work with overrides
export function getBoundaries(lat, long) {
    return fetch(`/api/maps/SchoolBoundariesGeoJSON?year=2022&latitude=${lat}&longitude=${long}`)
        .then(res => res.json())
}

// @TODO refactor to  work with overrides
export function getAllBoundaries() {
    return fetch(`/api/maps/SchoolBoundariesGeoJSON?year=2022`)
        .then(res => res.json())
}

export function getDirectionsUrl(address) {

    return `https://maps.google.com/maps?daddr=${encodeURIComponent(address)}`
}

export function getTier(lat, long) {
    // check to see if more than one tier result was returned. If so, assume the address searched was outside of Chicago and use a -1 for the tier value
    return getMapName('TIER', 2022, 'gocps', {
        latitude: lat,
        longitude: long
    }).then(res => res.features.length == 1 ? res.features[0].properties.Tier : -1);
}

export function getReverseGeocode(lat: number, lng: number): Promise<string> {

    const geocoder = new google.maps.Geocoder();
    return new Promise<string>((res, rej) => {
        geocoder.geocode({
            location: { lat: lat, lng: lng }
        }, (result, status) => {
            if (status == google.maps.GeocoderStatus.OK) {
                res(result.length ? result[0].formatted_address : '');
                return;
            }
            rej(status);
        })
    });

}

/* LongPress event functions */

export function LongPress(map, length) {
    console.log('LongPress function: ', map, length)
    this.length_ = length;
    var me = this;
    me.map_ = map;
    me.timeoutId_ = null;
    google.maps.event.addListener(map, 'mousedown', function (e) {
        me.onMouseDown_(e);
    });
    google.maps.event.addListener(map, 'mouseup', function (e) {
        me.onMouseUp_(e);
    });
    google.maps.event.addListener(map, 'drag', function (e) {
        me.onMapDrag_(e);
    });
}
LongPress.prototype.onMouseUp_ = function (e) {
    clearTimeout(this.timeoutId_);
};

LongPress.prototype.onMouseDown_ = function (e) {
    clearTimeout(this.timeoutId_);
    var map = this.map_;
    var event = e;
    this.timeoutId_ = setTimeout(function () {
        google.maps.event.trigger(map, 'longpress', event);
    }, this.length_);
};

LongPress.prototype.onMapDrag_ = function (e) {
    clearTimeout(this.timeoutId_);
};
/* End LongPress event functions */

export function addrFromLatLng(latLngPoint) {
    return new Promise((resolve, reject) => {
        var googleGeocoder = new google.maps.Geocoder();
        googleGeocoder.geocode(({ 'location': latLngPoint }), function (results, status) {
            //console.log('results: ', results)
            //console.log('status: ', status)
            if (status == google.maps.GeocoderStatus.OK) {
                if (results[0]) {
                    resolve(results[0]);
                }
            }
        });
    })
}
